import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../lib/supabase';

export function useActivityTracker() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const updateActivity = async () => {
      try {
        const { error } = await supabase
          .from('user_activity')
          .upsert({
            user_id: user.id,
            last_seen: new Date().toISOString(),
            page_url: window.location.pathname
          }, {
            onConflict: 'user_id'
          });

        if (error && error.code !== 'PGRST116') {
          console.error('Error updating activity:', error);
        }
      } catch (err) {
        console.error('Error in updateActivity:', err);
      }
    };

    updateActivity();

    const interval = setInterval(updateActivity, 30000);

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        updateActivity();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [user]);
}
